import React from "react";

import "./style.scss";

const ALLOWED_WAGONS = [
  { src: "/img/restrictions/folding-wagon-red.png", alt: "Red folding wagon" },
  {
    src: "/img/restrictions/folding-beach-wagon-blue.png",
    alt: "Blue folding beach wagon",
  },
];

const ALLOWED_OTHER = [
  {
    src: "/img/restrictions/wire-folding-shopping-cart.png",
    alt: "Wire folding shopping cart",
  },
  { src: "/img/restrictions/hand-truck.png", alt: "Hand truck" },
  { src: "/img/restrictions/beach-cart-blue.png", alt: "Blue beach cart" },
];

const NOT_ALLOWED_ITEMS = [
  { src: "/img/restrictions/tilt-dump-cart.png", alt: "Tilt dump cart" },
  { src: "/img/restrictions/utility-cart.png", alt: "Utility cart" },
  {
    src: "/img/restrictions/two-tier-basket-cart.png",
    alt: "Two-tier basket cart",
  },
  {
    src: "/img/restrictions/plastic-shopping-cart.png",
    alt: "Plastic shopping cart",
  },
  { src: "/img/restrictions/garden-dump-cart.png", alt: "Garden dump cart" },
  {
    src: "/img/restrictions/red-mesh-garden-wagon.png",
    alt: "Red mesh garden wagon",
  },
];

const OVERSIZED_ITEMS = [
  {
    src: "/img/restrictions/folding-wagon-with-tailgate.png",
    alt: "Folding wagon with tailgate extension",
  },
  {
    src: "/img/restrictions/folding-wagon-gray.png",
    alt: "Oversized gray folding wagon",
  },
  {
    src: "/img/restrictions/folding-wagon-red-with-groceries.png",
    alt: "Folding wagon overloaded with groceries",
  },
  {
    src: "/img/restrictions/wire-shopping-cart-with-groceries.png",
    alt: "Wire shopping cart overloaded with groceries",
  },
];

const COOLER_ITEMS = [
  { src: "/img/restrictions/hard-cooler.png", alt: "Oversized hard cooler" },
  {
    src: "/img/restrictions/large-wheeled-cooler.png",
    alt: "Large wheeled cooler",
  },
];

const PropaneTankSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M384 48C419.3 48 448 76.7 448 112L448 181.6C485.3 194.8 512 230.3 512 272L512 320L520 320C533.3 320 544 330.7 544 344C544 357.3 533.3 368 520 368L512 368L512 432C512 473.8 485.3 509.2 448 522.4L448 544C448 561.7 433.7 576 416 576L224 576C206.3 576 192 561.7 192 544L192 522.4C156.2 509.7 130.1 476.6 128.1 436.9L128 432L128 368L120 368C106.7 368 96 357.3 96 344C96 330.7 106.7 320 120 320L128 320L128 272C128 230.2 154.7 194.8 192 181.6L192 112C192 76.7 220.7 48 256 48L384 48zM176 432C176 458.5 197.5 480 224 480L416 480C442.5 480 464 458.5 464 432L464 368L176 368L176 432zM224 224C197.5 224 176 245.5 176 272L176 320L464 320L464 272C464 245.5 442.5 224 416 224L224 224zM280 96C266.7 96 256 106.7 256 120C256 133.3 266.7 144 280 144L296 144L296 176L344 176L344 144L360 144C373.3 144 384 133.3 384 120C384 106.7 373.3 96 360 96L280 96z"
    />
  </svg>
);

const ApplianceSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M448 112C474.5 112 496 133.5 496 160L496 240L144 240L144 160C144 133.5 165.5 112 192 112L448 112zM496 288L496 512C496 520.8 488.8 528 480 528L160 528C151.2 528 144 520.8 144 512L144 288L496 288zM192 64C139 64 96 107 96 160L96 512C96 547.3 124.7 576 160 576L480 576C515.3 576 544 547.3 544 512L544 160C544 107 501 64 448 64L192 64zM224 176C224 162.7 213.3 152 200 152C186.7 152 176 162.7 176 176C176 189.3 186.7 200 200 200C213.3 200 224 189.3 224 176zM280 200C293.3 200 304 189.3 304 176C304 162.7 293.3 152 280 152C266.7 152 256 162.7 256 176C256 189.3 266.7 200 280 200zM384 176C384 162.7 373.3 152 360 152C346.7 152 336 162.7 336 176C336 189.3 346.7 200 360 200C373.3 200 384 189.3 384 176zM440 200C453.3 200 464 189.3 464 176C464 162.7 453.3 152 440 152C426.7 152 416 162.7 416 176C416 189.3 426.7 200 440 200zM192 360C192 373.3 202.7 384 216 384L424 384C437.3 384 448 373.3 448 360C448 346.7 437.3 336 424 336L216 336C202.7 336 192 346.7 192 360z"
    />
  </svg>
);

const PlantsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M376 48C433.4 48 480 94.6 480 152C480 172.7 473.9 191.8 463.5 208C473.9 224.2 480 243.3 480 264C480 321.4 433.4 368 376 368C364.8 368 354.1 366.1 344 362.8L344 439.1C374.2 407.2 416.1 386.5 462.9 384.1L472 383.9L514.5 383.9L517.5 384.1C532.4 385.6 544 398.2 544 413.5L543.8 421.9C539.6 505 473 571.6 389.9 575.8L381.5 576L258.4 576L250 575.8C167 571.6 100.4 505 96.2 421.9L96 413.5C96 398.2 107.6 385.6 122.5 384.1L125.5 383.9L168 383.9L177.1 384.1C223.9 386.5 265.9 407.1 296 439.1L296 362.8C285.9 366.1 275.2 368 264 368C206.6 368 160 321.4 160 264C160 243.4 166.1 224.2 176.5 208C166.1 191.8 160 172.6 160 152C160 94.6 206.6 48 264 48C284.6 48 303.8 54.1 320 64.5C336.2 54.1 355.4 48 376 48zM145.5 432C154.3 486.4 201.5 528 258.5 528L292 528C277.8 472.8 227.7 432 168 432L145.5 432zM472 432C412.4 432 362.2 472.8 348 528L381.5 528C438.4 528 485.6 486.4 494.5 432L472 432zM376 96C362.6 96 350.4 100.7 340.8 108.5L336.8 112C328.6 120 316.2 121 306.9 115L303.1 112C293 102.1 279.2 96 263.9 96C233 96 207.9 121.1 207.9 152C207.9 167.3 214 181 223.9 191.2L226.9 195C232.1 202.9 232.1 213.2 226.9 221.1L223.9 224.9C214 235 207.9 248.8 207.9 264.1C207.9 295 233 320.1 263.9 320.1C279.1 320.1 292.9 314 303.1 304L306.9 301C316.1 295 328.6 296 336.8 304C347 314 360.7 320.1 376 320.1C406.9 320.1 432 295 432 264.1C432 250.8 427.3 238.5 419.5 228.9L415.9 224.9C406.7 215.6 406.7 200.6 415.9 191.3C425.9 181.1 432 167.4 432 152.1C432 121.2 406.9 96.1 376 96.1zM320 240C302.3 240 288 225.7 288 208C288 190.3 302.3 176 320 176C337.7 176 352 190.3 352 208C352 225.7 337.7 240 320 240z"
    />
  </svg>
);

const GroceriesSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M464 112L512 112C520.8 112 528 119.2 528 128L528 512C528 520.8 520.8 528 512 528L430.9 528C428.4 545.7 421.7 562 412 576L512 576C547.3 576 576 547.3 576 512L576 128C576 92.7 547.3 64 512 64L256 64C220.7 64 192 92.7 192 128L192 208L240 208L240 128C240 119.2 247.2 112 256 112L304 112L304 184C304 197.3 314.7 208 328 208L440 208C453.3 208 464 197.3 464 184L464 112zM416 112L416 160L352 160L352 112L416 112zM336 512C336 520.8 328.8 528 320 528L128 528C119.2 528 112 520.8 112 512L112 400L336 400L336 512zM64 387.8L64 512C64 547.3 92.7 576 128 576L320 576C355.3 576 384 547.3 384 512L384 387.8C393.8 379 400 366.2 400 352L400 304C400 277.5 378.5 256 352 256L96 256C69.5 256 48 277.5 48 304L48 352C48 366.2 54.2 379 64 387.8zM96 352L96 304L352 304L352 352L96 352z"
    />
  </svg>
);

const PROHIBITED_ICONS = [
  { svg: <PropaneTankSvg />, label: "Propane Tanks" },
  { icon: "fas fa-tint", label: "Flammable Liquids" },
  { icon: "fas fa-tv", label: "TVs" },
  { svg: <ApplianceSvg />, label: "Household Appliances" },
  { svg: <PlantsSvg />, label: "Plants & Garden Supplies" },
  { icon: "fas fa-weight-hanging", label: "Items Over 50lbs" },
  { icon: "fas fa-bicycle", label: "Bicycles & E-Bikes" },
  { svg: <GroceriesSvg />, label: "Bulk Beverages or Groceries" },
];

const ImageRow = ({ items }) => (
  <div className="pfp-image-row">
    {items.map((item) => (
      <img key={item.src} src={item.src} alt={item.alt} />
    ))}
  </div>
);

const PassengerFreightPolicy = () => (
  <div className="passenger-freight-policy">
    <div className="pfp-headline">
      <h2>Don&rsquo;t Miss The Boat</h2>
      <p>
        Please be advised that we will strictly enforce our existing passenger
        freight policy regarding overweight or oversized wagons, coolers, and
        packing totes this summer. Anything non-perishable can be refused. This
        applies to travelling in both directions to all beaches, with a
        particular focus on departures from Ocean Beach on Sunday mornings and
        during midday trips.
      </p>
    </div>

    <div className="pfp-callout">
      <i className="fas fa-info-circle" />
      <div>
        <strong>Avoid Refusal &amp; Delays on Sundays</strong>
        <p>
          Use the <strong>Saturday Freight Boat</strong> to return bulk items a
          day early. Your items will be held in our freight house for pickup on
          Sunday.
        </p>
      </div>
    </div>

    <section className="pfp-section pfp-allowed">
      <header>
        <h3>
          <i className="fas fa-check" /> ALLOWED <span>on Passenger Boats</span>
        </h3>
        <span className="pfp-badge">Max Weight: 50lbs</span>
      </header>
      <div className="pfp-subhead">
        <span>
          <i className="fas fa-exclamation-triangle" />{" "}
          <strong>Only one wagon per party</strong>
        </span>
      </div>
      <div className="pfp-allowed-content">
        <div className="pfp-allowed-wagons-group">
          <span className="pfp-allowed-max-size">
            <strong>Max Size:</strong> 40&rdquo; x 24&rdquo; x 30&rdquo;
          </span>
          <div className="pfp-image-row pfp-allowed-wagons">
            {ALLOWED_WAGONS.map((item) => (
              <img key={item.src} src={item.src} alt={item.alt} />
            ))}
          </div>
        </div>
        <div className="pfp-allowed-other">
          {ALLOWED_OTHER.map((item) => (
            <img key={item.src} src={item.src} alt={item.alt} />
          ))}
        </div>
      </div>
    </section>

    <section className="pfp-section pfp-not-allowed">
      <header>
        <h3>
          <i className="fas fa-times" /> NOT ALLOWED{" "}
          <span>on Passenger Boats</span>
        </h3>
      </header>
      <ImageRow items={NOT_ALLOWED_ITEMS} />

      <div className="pfp-subgroup">
        <h4>
          <i className="fas fa-times" /> No oversized or overloaded carts or
          wagons
        </h4>
        <ImageRow items={OVERSIZED_ITEMS} />
      </div>

      <div className="pfp-subgroup">
        <h4>
          <i className="fas fa-times" /> No coolers over 50lbs or larger than
          40&rdquo; x 30&rdquo; x 20&rdquo; (110qts)
        </h4>
        <div className="pfp-cooler-row">
          <p>
            Oversized coolers are not allowed and must be shipped on the freight
            boat, even if empty or in a wagon.
          </p>
          <div className="pfp-image-row">
            {COOLER_ITEMS.map((item) => (
              <img key={item.src} src={item.src} alt={item.alt} />
            ))}
          </div>
        </div>
      </div>

      <ul className="pfp-prohibited-icons">
        {PROHIBITED_ICONS.map((item) => (
          <li key={item.label}>
            <span className="pfp-prohibited-circle">
              {item.svg ? item.svg : <i className={item.icon} />}
            </span>
            <span className="pfp-prohibited-label">{item.label}</span>
          </li>
        ))}
      </ul>
    </section>
  </div>
);

export default PassengerFreightPolicy;
